import { useAuth0 } from '@auth0/auth0-react';
import { FeedbackButton } from '@strata/react-buttons';
import { BlankScreen } from '@strata/react-page-templates';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router';

import { Header } from 'components/header/Header';
import { LOGIN_REDIRECT_KEY } from 'services/constants';
import { handleError } from 'services/Error';
import { AppRoutes } from 'services/routes';

/** Routes that header is hidden on */
const NoHeaderRoutes = [
    AppRoutes.termsAndConditions,
    AppRoutes.termsOfUse,
    AppRoutes.privacyPolicy,
    AppRoutes.updatesHistory,
];

/**
 * Component to determine if a user is authenticated and
 * if they are allowed to visit the page they navigated to.
 *
 * If they are: they proceed to the page
 * If not: they are redirected to the login page.
 */
export const RequireAuth = () => {
    const { isAuthenticated, loginWithRedirect } = useAuth0();
    const location = useLocation();

    // Ensure permissions and profile are loaded
    const { permissions } = useSelector((state) => state.auth);
    useEffect(() => {
        if (isAuthenticated) {
            if (permissions.length === 0) {
                handleError('User is not configured for this application.');
            }
        }
    }, [isAuthenticated, permissions]);

    if (!isAuthenticated) {
        sessionStorage.setItem(LOGIN_REDIRECT_KEY, location.pathname);
        loginWithRedirect();
        return <BlankScreen />;
    }

    return (
        <>
            {!NoHeaderRoutes.includes(location.pathname) && <Header />}
            <Outlet />
            <FeedbackButton hideButton />
        </>
    );
};
